const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve a file URL from the database.
 * - Full URLs (http/https/data/blob) are returned as-is
 * - Storage paths (e.g. "vvf-interventi/photos/uuid.jpg") are proxied through the API
 */
export function resolveFileUrl(url) {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:') || url.startsWith('blob:')) return url;
  return `${API_URL}/api/files/${url}`;
}
